import { getImageDirectUploadData } from '../../../../utils/getImageDirectUploadData'
import type { FormValues } from '../../types'
import { getCommonFieldsPayload } from './getCommonFieldsPayload'

export const getAudioPostPayload = async (values: FormValues) => {
  const payload = getCommonFieldsPayload(values)

  return {
    ...payload,
    imageDirectUploadData:
      typeof values.audioThumbnail === 'object'
        ? await getImageDirectUploadData(values.audioThumbnail as File)
        : undefined,
    new_media_direct_upload: typeof values.audio === 'object',
  }
}
